export enum DivisionDetailsTabs {
    PREVIEW = 'PREVIEW',
    INVITATIONS = 'INVITATIONS',
    EXPERTS = 'EXPERTS',
    COMPANY_DATA = 'COMPANY_DATA',
};
